document.addEventListener("turbolinks:load", function () {
  $globalSearchInput = $('*[data-behavior="global-autocomplete"]')
  var options = {
    url: function (phrase) {
      return "/patients/search.json?q=" + phrase;
    },
    getValue: "name",
    categories: [
      {
        listLocation: "patients",
        header: "<strong>Patients</strong>",
      },
      {
        listLocation: "medicines",
        header: "<strong>Medicines</strong>",
      }
    ],
    list: {
      onChooseEvent: function () {
        var url = $globalSearchInput.getSelectedItemData().url
        $globalSearchInput.val("")
        Turbolinks.visit(url)
      },
      // Fingure out why this param is not taking effect
      maxNumberOfElements: 10,
    },
  };

  $globalSearchInput.easyAutocomplete(options);
});